<template>
  <div class="pageContainer">
    <!--联系方式----开始-->
    <!--百度地图加载-->
    <div class="contact">
      <div class="content">
        <el-row type="flex" justify="space-between" :gutter="88">
<!--          <el-col :span="11">-->
<!--            <baidu-map :zoom="11" @ready="initMap" class="bm-view" :scroll-wheel-zoom='true'>-->
<!--              &lt;!&ndash; scroll-wheel-zoom：能否通过滚轮缩放地图 &ndash;&gt;-->
<!--            </baidu-map>-->
<!--          </el-col>-->
          <el-col :span="12">
            <p v-for="item in settings.footer" :key="item.name">
              <label>{{item.name}}</label><span>{{item.text}}</span>
            </p>
          </el-col>
          <el-col :span="12" class="qrContainer">
            <div >
              <p>
                奥云AI微信小程序
              </p>
              <img src="../../assets/pcimages/ai-qr.png" />
            </div>
            <div>
              <p>
                奥云技术<br />微信视频号
              </p>
              <img src="../../assets/pcimages/sph.png" />
            </div>
            <div>
              <p>
                 奥云技术支持群
              </p>
              <img src="../../assets/pcimages/wxq.png" />
            </div>
            <div>
            <p>
              奥云公众号
            </p>
            <img src="../../assets/pcimages/contact_qr_new.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--联系方式----结束-->
    <div class="footer">
      <p >
        Email：a15647188816@163.com<br />
        ©2016 内蒙古奥云信息技术服务有限公司 版权所有<br />
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001520" style="display:inline-block;margin: 0 15px;"   target="_blank">
          <img src="../../assets/images/baImg.png">蒙公网安备 15010502001520号</a>
        <a href="http://beian.miit.gov.cn/"   target="_blank">蒙ICP备18000606号-1</a>
      </p>
    </div>
  </div>

</template>
<script>
export default {
  name: 'vFooter',
  methods: {
    initMap ({BMap, map}) {
      // 百度地图API功能
      map.centerAndZoom(new BMap.Point(111.737555, 40.778061), 11)

      var local = new BMap.LocalSearch(map, {
        renderOptions: {
          map: map
        }
      })
      local.search('内蒙古奥云信息技术')
    }
  }
}
</script>
<style lang="scss" scoped>
.contact {
  background: url(../../assets/pcimages/contact_bg.png) no-repeat left #00a0e9;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue